
export const hodInfo = [
  {
    teacherName: 'Mrs. Denise Aguilar',
    email: 'daguilar@sca.edu.bz',
    image: require('../../../assets/Images/Teachers/DAguilar.webp'),
    position: 'Head of Department',
    subjects: ['English A CSEC', 'English B CSEC', 'English Language', 'Literature', 'Integrated English', 'French'],
  },
]

export const teacherList = [

  {
    teacherName: 'Mrs. Tara Castillo',
    email: 'tcastillo@sca.edu.bz',
    image: require('../../../assets/Images/Teachers/TCastillo.webp'),
    subjects: ['Integrated English'],
  },
  {
    teacherName: 'Mrs. Janine Cattouse',
    email: 'jcattouse@sca.edu.bz',
    image: require('../../../assets/Images/Teachers/JCattouse.webp'),
    subjects: ['English A CSEC'],
  },
  {
    teacherName: 'Mrs. Samantha Muñoz',
    email: 'smunoz@sca.edu.bz',
    image: require('../../../assets/Images/Teachers/SMunoz.webp'),
    subjects: ['Integrated English'],
  },
  {
    teacherName: 'Ms. Tamarah Phillips',
    email: 'tphillips@sca.edu.bz',
    image: require('../../../assets/Images/Teachers/TPhillips.webp'),
    subjects: ['English A CSEC'],
  },
  {
    teacherName: 'Ms. Blaire Santos',
    email: 'bsantos@sca.edu.bz',
    image: require('../../../assets/Images/Teachers/BSantos.webp'),
    subjects: ['Integrated English'],
  },
  {
    teacherName: 'Ms. Jasibi Urbina',
    email: 'jurbina@sca.edu.bz',
    image: require('../../../assets/Images/Teachers/JUrbina.webp'),
    subjects: ['Integrated English', 'Graphic Design'],
  },
]
